import { abbreviateBigNumber } from "./abbreviate-big-number";

type intervalStringType = "10%" | "20%" | "30%";

// not used ATM
/* const roundTo4Decimals = (value: number) => {
  const roundedValue = Math.round(value * 1e1) / 1e1;
  return roundedValue;
}; */

export const manipulateValue = (value: number) => {
  const returnedValue = abbreviateBigNumber(value);
  return returnedValue;
};

export const calculateValuesInterval = (
  valuesArray: number[],
  margin: intervalStringType,
): { yAxisMin: number | string; yAxisMax: number | string } => {
  const percentage = parseInt(margin.slice(0, -1), 10) / 100;

  const minValue = Math.min(...valuesArray);
  const maxValue = Math.max(...valuesArray);
  const valueRange = maxValue - minValue;

  const yAxisMin = minValue - percentage * valueRange;
  const yAxisMax = maxValue + percentage * valueRange;

  return {
    yAxisMin: yAxisMin,
    yAxisMax: yAxisMax,
  };
};
